import { useContext } from "react";
import AppContext from "../context/AppContext";
import { jwtDecode } from "jwt-decode";
import "core-js/stable/atob"; // Decoding Token fallback layer

const useAuth = () => {
  const {
    auth,
    setAuth,
    userToken,
    logOut,
    setUserInfo,
    userInfo,
    isReverified,
    reverifyUser,
    activitySettings,
    setActivitySettings,
    updateInteraction,
  } = useContext(AppContext);

  // 1. ACTIVE SESSION STATE: User is logged in, extract payload elements cleanly
  if (auth?.accessToken) {
    const decoded = jwtDecode(auth.accessToken);
    const {
      sub,
      firstname,
      lastname,
      username,
      email,
      phoneNumber,
      pullCred,
      image,
      isGuest,
      hasDVA,
      isVerifiedForPayment,
      isBlockedAccess,
      isEmailVerified,
      hasUnacknowledgedRedemption: tokenRedemption,
    } = decoded.UserInfo;

    return {
      sub,
      firstname,
      lastname,
      username,
      email,
      phoneNumber,
      image,
      isGuest,
      hasDVA,
      pullCred,
      isVerifiedForPayment,
      isEmailVerified,
      isBlockedAccess,

      hasUnacknowledgedRedemption: auth?.hasUnacknowledgedRedemption ?? tokenRedemption ?? false,

      // App contexts and methods
      isReverified,
      reverifyUser,
      activitySettings,
      updateInteraction,
      setActivitySettings,
      logOut,
      auth,
      setAuth,
      userToken,
    };
  }

  // 2. UNAUTHENTICATED / COLD START STATE: No memory token available yet
  // 🔒 UPDATE: Removed dead localized state parameters (authLocalStorage, setAuthLocalStorage)
  return {
    auth,
    userToken, // Null when logged out
    logOut,
    setUserInfo,
    userInfo,
    activitySettings,
    isReverified,
    reverifyUser,
    setActivitySettings,
    updateInteraction,
    // hasUnacknowledgedRedemption: false,

    // // Explicit structural fallbacks so your frontend UI grids don't throw reading properties undefined errors
    // sub: null,
    // firstname: "Guest",
    // lastname: "",
    // username: "",
    // email: "",
    // phoneNumber: "",
    // image: null,
    // isGuest: true, // Defaults safely to guest tier permissions layout on initial land
    // hasDVA: false,
    // pullCred: 0,
    // isVerifiedForPayment: false,
    // isEmailVerified: false,
    // isBlockedAccess: false,
  };
};

export default useAuth;
